import { parseCookie } from '../../utilities/utils';
import { timeout } from '../../utilities/promises';
import { offers } from '../../api/client/adobe';
import { experimentParams } from '../../components/experiments/offers';

/** If there is no mbox cookie bail out early.
 *  If there is an mbox cookie timeout if offers do not load
 */
export const noConsentBailout = () => {
    if (!parseCookie('mbox')) {
        return Promise.resolve();
    } else {
        return timeout(2000);
    }
};

export const adobeData = () => Promise.any([offers, noConsentBailout()]).then(experimentParams);
